// extracted by mini-css-extract-plugin
module.exports = {"ReportPanel":"ReportPanel_ReportPanel__2E1hl"};